import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'faq-list-view',
  templateUrl: './faq-list-view.component.html',
  styleUrl: './faq-list-view.component.scss',
  standalone: false,
})
export class FrequentlyAskedQuestionsListViewComponent {
  @Input() frequentlyAskedQuestions: app.models.FAQModel[];
  @Input() props: app.models.DynamicPropsDictionary;
  @Input() isFiltered: boolean;
  @Input() lastQuestionOrder: number;
  @Output() deleteFrequentlyAskedQuestionEvent: EventEmitter<string> = new EventEmitter<string>();
  @Output() editDetailsEvent: EventEmitter<string> = new EventEmitter<string>();
  @Output() orderChangeEvent = new EventEmitter<void>();

  public firstQuestionOrder: number = 1;

  public deleteFrequentlyAskedQuestion(frequentlyAskedQuestionId: string) {
    this.deleteFrequentlyAskedQuestionEvent.emit(frequentlyAskedQuestionId);
  }

  public editDetails(frequentlyAskedQuestionId: string) {
    this.editDetailsEvent.emit(frequentlyAskedQuestionId);
  }

  public orderChange() {
    this.orderChangeEvent.emit();
  }

  moveFrequentlyAskedQuestionUp(index: number): void {
    if (index > 0) {
      [this.frequentlyAskedQuestions[index], this.frequentlyAskedQuestions[index - 1]] = [
        this.frequentlyAskedQuestions[index - 1],
        this.frequentlyAskedQuestions[index],
      ];
      this.orderChange();
    }
  }

  moveFrequentlyAskedQuestionDown(index: number): void {
    if (index < this.frequentlyAskedQuestions.length - 1) {
      [this.frequentlyAskedQuestions[index], this.frequentlyAskedQuestions[index + 1]] = [
        this.frequentlyAskedQuestions[index + 1],
        this.frequentlyAskedQuestions[index],
      ];
      this.orderChange();
    }
  }
}
